import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ArtisanBottomNav from "@/components/ArtisanBottomNav";
import AppointmentHistory from "@/components/AppointmentHistory";
import { useAuth } from "@/contexts/AuthContext";
import { useEffect } from "react";
import { useSEO } from "@/hooks/useSEO";
import { useLocalizedNavigate } from "@/hooks/useLocalizedNavigate";

const MesRdvArtisan = () => {
  useSEO({ noindex: true });
  const { user, loading: authLoading } = useAuth();
  const lNavigate = useLocalizedNavigate();

  useEffect(() => {
    if (!authLoading && !user) lNavigate("/connexion");
  }, [user, authLoading]);

  if (authLoading) return null;

  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="container max-w-2xl py-8 pb-24">
        <AppointmentHistory />
      </main>
      <Footer />
      <ArtisanBottomNav />
    </div>
  );
};

export default MesRdvArtisan;
